// extracted by mini-css-extract-plugin
export default {"TasksPage":"TasksPage_TasksPage__m4sB2","btn__container":"TasksPage_btn__container__aibaT","addProject__btn":"TasksPage_addProject__btn__02iUL"};